import { render } from "./DeliveryEnd.vue?vue&type=template&id=aa12d44e"
import script from "./DeliveryEnd.vue?vue&type=script&lang=js"
export * from "./DeliveryEnd.vue?vue&type=script&lang=js"
script.render = render

export default script